export default __webpack_public_path__ + "8dc175679e57ff139a1069df3a54a8b7.jpg";